import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-call-to-action',
  templateUrl: './landing-call-to-action.component.html',
  styleUrls: ['./landing-call-to-action.component.scss']
})
export class LandingCallToActionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
